export function difference(results, gauge) {
  if (gauge) return results[0] - results[1]
  // Old deprecated way after this early return
  const { queries } = gauge
  return queries[0].result - queries[1].result
}
